import { Inject, Injectable } from '@angular/core';
import { ISettingsServiceInterface } from './settings-service.interface';
import { Value } from '../environment/environment.interface';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environment/environment.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsService implements ISettingsServiceInterface {
  private endpointApi: Value;
  public settings: Record<string, Record<string, any>> = {};

  constructor(private http: HttpClient, @Inject('IEnvironmentService') private envService: EnvironmentService) {
    this.endpointApi = this.envService.getVar('services.api');
  }

  public loadSettings(): Observable<any> {
    return this.http.get(`${this.endpointApi}/affiliate/settings`);
  }

  public saveSettingsByKey(pageKey: string, settingKey: string, value: any): void {
    if (!this.settings[pageKey]) {
      this.settings[pageKey] = {};
    }
    if (value) {
      this.settings[pageKey][settingKey] = value;
    } else {
      delete this.settings[pageKey][settingKey];
    }
    this.http
      .post(`${this.endpointApi}/affiliate/settings`, {
        settings: this.settings,
      })
      .subscribe();
  }
}
